/* A Atölye · hediye ilerlemesi çalışma zamanı (site yenileme "b" listesi, 2026-10-13; BOGOS'un sepet çubuğu + yüzen düğme
   booster'larının yerine). Kaynak: site-yenileme/tema/6-uygulama/dosyalar/assets/a-hediye.js (kurucu kur.py; temada elle düzenleme ezilir).
   Hesap BURADA YOK: kural snippets/a-hediye-ilerleme.liquid'de, sayfa zaten doğru durumla basılır. Bu dosya yalnız:
   1) Sol alt düğme: paneli aç/kapat (tık, Esc, dışarı tık), odak yönetimi.
   2) Sepet değişince durumu tazeler. Sepete yazan HER istek (tema, BOGOS, set oluşturucu, eklentiler; fetch ya da XHR) PerformanceObserver
      ile görülür, kimsenin fetch'ine dokunulmaz → `/?sections=a-hediye-ilerleme` (Section Rendering API) → açık sayfadaki çubuğa ve düğmeye
      uygulanır. BOGOS hediyeyi kendi isteğiyle eklediğinde o istek de görülür, durum ikinci kez tazelenir.
   3) Eşik denetimi: BOGOS'un yayındaki teklifleri (window.fgData) ile tema ayarındaki eşikler tutmuyorsa konsola uyarı, tema editöründe
      panelde kırmızı not (hediyeyi ekleyen BOGOS, gösteren tema; ikisi ayrışırsa müşteri yanlış söz görür). */
(function () {
  if (window.AHediye) return;
  var A = (window.AHediye = {});
  var KOK = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SEPET_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;

  function uygula(d) {
    A.son = d;
    document.querySelectorAll('[data-a-hd]').forEach(function (kok) {
      var tur = kok.getAttribute('data-a-hd');
      if (tur === 'cubuk') kok.hidden = !d.aktif || d.bos;
      if (tur === 'ikon') kok.hidden = !d.aktif;
      kok.querySelectorAll('[data-a-hd-mesaj]').forEach(function (m) { if (m.innerHTML !== d.mesaj) m.innerHTML = d.mesaj; });
      kok.querySelectorAll('[data-a-hd-rozet]').forEach(function (r) {   // kazanılan hediye sayısı (4 / 5 / 6), kademe yokken gizli
        r.textContent = d.rozet || '';
        r.hidden = !d.rozet;
      });
      kok.querySelectorAll('[data-a-hd-dolgu]').forEach(function (b) { b.style.setProperty('--f', d.g); });   // saat gibi dolan düğme
      kok.querySelectorAll('[data-a-hd-cetvel]').forEach(function (c) {   // orantılı cetvel: dolgu + yeşil kısım (0-1)
        c.style.setProperty('--a-dolu', d.g);
        c.style.setProperty('--a-dolu-k', d.gk);
      });
      kok.querySelectorAll('[data-a-hd-kademe]').forEach(function (el) {
        var no = +el.getAttribute('data-a-hd-kademe'), k = null;
        for (var i = 0; i < d.k.length; i++) if (d.k[i].no === no) k = d.k[i];
        if (!k) return;
        el.classList.toggle('is-ulasti', !!k.u);
        el.classList.toggle('is-sirada', !k.u && !!k.s);
      });
    });
    document.dispatchEvent(new CustomEvent('a-hediye:durum', { detail: d }));
  }

  var zaman, istek = 0;
  function cek() {
    var no = ++istek;
    fetch(KOK + '?sections=a-hediye-ilerleme', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || no !== istek) return;   // arkadan gelen eski cevap yenisini ezmesin
        var m = String(j['a-hediye-ilerleme'] || '').match(/<script type="application\/json" data-a-hd-durum>([\s\S]*?)<\/script>/);
        if (m) uygula(JSON.parse(m[1]));
      })
      .catch(function () {});
  }
  function tazele() { clearTimeout(zaman); zaman = setTimeout(cek, 300); }
  A.tazele = tazele;

  try {
    new PerformanceObserver(function (liste) {
      liste.getEntries().forEach(function (e) { if (SEPET_RE.test(e.name)) tazele(); });
    }).observe({ type: 'resource', buffered: false });
  } catch (e) { /* çok eski tarayıcı: aşağıdaki olaylar yeter */ }
  document.addEventListener('cart:updated', tazele);   // Stiletto (özel olaylar açıksa)
  window.addEventListener('pageshow', function (e) { if (e.persisted) tazele(); });   // geri tuşu (bfcache)
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') tazele(); });   // başka sekmede değişmiş olabilir

  // ── sol alt düğme + panel ──
  function kur(kok) {
    if (kok.dataset.kuruldu) return;
    kok.dataset.kuruldu = '1';
    var dugme = kok.querySelector('[data-a-hk-dugme]'), panel = kok.querySelector('[data-a-hk-panel]'), kapat = kok.querySelector('[data-a-hk-kapat]');
    if (!dugme || !panel) return;
    function ac(acik, odakla) {
      panel.hidden = !acik;
      dugme.setAttribute('aria-expanded', acik ? 'true' : 'false');
      if (acik) {
        tazele();
        if (odakla && kapat) kapat.focus({ preventScroll: true });
      } else if (odakla) dugme.focus({ preventScroll: true });
    }
    dugme.addEventListener('click', function () { ac(panel.hidden, true); });
    if (kapat) kapat.addEventListener('click', function () { ac(false, true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) ac(false, true); });
    document.addEventListener('click', function (e) { if (!panel.hidden && !kok.contains(e.target)) ac(false, false); });
    denetle(kok, 0);
  }

  // ── eşik denetimi (BOGOS ↔ tema ayarı) ──
  function denetle(kok, deneme) {
    var fg = window.fgData;
    if (!fg || !fg.offers) {
      if (deneme < 30) setTimeout(function () { denetle(kok, deneme + 1); }, 500);
      return;
    }
    var simdi = Date.now(), bogos = [];
    fg.offers.forEach(function (o) {
      var bas = o.start_time ? Date.parse(o.start_time) : 0, son = o.end_time ? Date.parse(o.end_time) : Infinity;
      if (simdi < bas || simdi > son) return;
      (o.offer_conditions || []).forEach(function (c) { if (c.unit === 'money') bogos.push(Math.round(+c.min_amount)); });
    });
    bogos.sort(function (a, b) { return a - b; });
    var bizim = (kok.getAttribute('data-esikler') || '').split(',').filter(Boolean).map(Number).sort(function (a, b) { return a - b; });
    if (bogos.join() === bizim.join()) return;
    var metin = 'Tema ayarındaki hediye eşikleri (' + bizim.join(' / ') + ' ₺) BOGOS panelindeki tekliflerle (' + (bogos.join(' / ') || 'yok') + ' ₺) tutmuyor.';
    console.warn('[A hediye]', metin);
    var uyari = kok.querySelector('[data-a-hk-uyari]');
    if (uyari && window.Shopify && window.Shopify.designMode) {
      uyari.textContent = metin + ' Tema ayarları → A · Hediye kampanyası.';
      uyari.hidden = false;
    }
  }

  function basla() { document.querySelectorAll('[data-a-hd="ikon"]').forEach(kur); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();
  document.addEventListener('shopify:section:load', basla);   // tema editörü
})();
